import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  alertSegcoop: {
    margin: theme.spacing(3, 0),
    padding: theme.spacing(2),
    fontSize: 16,
    cursor: 'pointer',
  },
}))

export default styles
